var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper",class:_vm.classObj},[_c('sidebar',{staticClass:"sidebar-container"}),_c('div',{staticClass:"main-container"},[_c('div',{staticClass:"fixed-header"},[_c('navbar'),_c('tags-view')],1),_c('app-main')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }